// let x = "Period rules for {Subject} for {Grades},{Sections} ";

let String = {
    create: (function () {
        let regex = /{([\w]+)}/g;
        return function (str, o) {
            return str.replace(regex, function (match, key) {
                return (key = o[key]) == null ? '' : key;
            });
        }
    })()
};

 export const getFormatedMessage = (template, substitutionObjects) =>  {
    let returnMessage = String.create(template, substitutionObjects);
    return returnMessage;
}

// const subject = "Kannada,English +2 More";
// const grades = "1";
// const sections = "A";

// const messageToShow = getFormatedMessage(stringTemplate,
//     {
//         Subject: "Kannada,English +2 More",
//         Grades: "1",
//         Sections: "A"
//     });